const DietsAndValuesContainer: React.FC<{
  children: React.ReactNode;
  size?: 'md' | 'lg';
}> = ({ children, size = 'md' }) => {
  return (
    <ul
      className={`tw-flex tw-flex-wrap ${
        size === 'lg' ? 'tw--mt-3' : 'tw--mt-2'
      }`}
    >
      {children}
    </ul>
  );
};

export default DietsAndValuesContainer;
